module.exports = __webpack_public_path__ + "img/Hp-IconBox2-global-Intelligence.3e842b56.svg";